import React, { useEffect, useState, useRef } from 'react';
import { Button, Button as ANTButton, Modal, notification, Popover, Space } from 'antd';
import Table from 'components/Table';
import { useSelector } from 'react-redux';
import './assets/style.css';
import { useQuery } from 'react-query';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { PageHeader } from '../../../components/Atom/PageHeader';
import { ResetButton, FilterButton } from '../../../components/Atom/Button';
import { ReloadOutlined } from '@ant-design/icons';
import Filter from './assets/filter';
import SearchField from '../../../components/Atom/SearchField/index';
import { getAllBillingInvoices } from 'api/subscriptions';
import { TIMEZONES } from 'utils/constant';
import { convertToSubscriptionTimezone, handleDateRangeFormat, handleStateByPassData } from 'utils/services';
import ShortenId from 'components/Atom/ShortenId';
import StatusTag from 'components/Atom/StatusTag';
import { useNavigate, useLocation } from 'react-router-dom';
import http from 'utils/http';

export const BillingInvoices = () => {
  const store = useSelector((state) => state?.company?.store);
  const [filterToggle, setFilterToggle] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [recordId, setRecordId] = useState('');
  const [delayTimer, setDelayTimer] = useState();
  const tableContainerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [search, setSearch] = useState('');

  const fetchData = async (queryParams) => {
    try {
      const paramsData = { offset: queryParams?.offset, limit: queryParams?.limit };
      if (queryParams?.search !== '') {
        paramsData['search_key'] = queryParams?.search?.trim();
      }
      const formattedData = filtersDataValues(queryParams?.filtersData);
      const params = { ...paramsData, ...formattedData, ...(store?.isSelected && { store_id: store?._id }), xap_request: true };
      const response = await getAllBillingInvoices(params);
      const timezone = store?.settings?.timezone || TIMEZONES?.PKT;
      const result = await convertToSubscriptionTimezone(response?.data?.data, timezone, 'invoices');
      response.data.data = result;
      return response?.data?.data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data, refetch, isLoading, isFetching } = useQuery('merchantBillingInvoices', () => fetchData(queryParams), {
    enabled: false,
    manual: true,
  });
  const [queryParams, setQueryParams] = useState({
    offset: 0,
    limit: 20,
    search: '',
    currentPage: 1,
  });
  const [trigerApi, setTrigerApi] = useState(true);
  const columnsData = [
    {
      title: 'Invoice ID',
      render: (value) => <ShortenId value={value?.invoice_id} /> || 'N/A',
      key: 'invoice_id',
      fixed: 'left',
    },
    {
      title: 'Status',
      render: (value) => <StatusTag tag={value?.state === 'draft' ? 'pending' : value?.state} /> || 'N/A',
      key: 'status',
    },
    {
      title: 'Subscription ID',
      render: (value) => <ShortenId value={value?.subscription_id?.subscription_id || value?.subscription_id} /> || 'N/A',
      key: 'subs_Id',
    },
    {
      title: 'plan ID',
      render: (value) => <ShortenId value={value?.plan_id} /> || 'N/A',
      key: 'plan_Id',
    },
    {
      title: 'Time',
      render: (value) => value?.updatedAt || 'N/A',
      key: 'updatedAt',
    },
  ];
  useEffect(() => {
    if (location?.state?.isRedirection && data) {
      setSearch(location?.state?.searchValue);
      setRecordId(location?.state?.id);
      navigate(location.pathname, { replace: true });
      const data = handleStateByPassData(location?.state?.filtersData, true);
      if (!data) {
        refetch();
      }
      setQueryParams(data);
      setTimeout(() => {
        if (tableContainerRef?.current && location?.state?.id) {
          const row = document?.querySelector(`.custom-row-class.highlighted-row`);
          if (row) {
            row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }, 10);
      return;
    } else if (location?.state?.isRedirection) {
      navigate(location.pathname, { replace: true });
    }
    refetch();
  }, [trigerApi, store]);
  const filtersDataValues = (data) => {
    let filtersData = {};
    if (data?.date_range) {
      const timezone = store?.isSelected ? store?.settings?.timezone || TIMEZONES.PKT : null;
      const { start_date, end_date } = handleDateRangeFormat(data?.date_range, timezone);
      filtersData.start_date = start_date;
      filtersData.end_date = end_date;
    }
    filtersData.state = data?.invoice_status ?? null;
    return filtersData;
  };
  const getSearch = async (e) => {
    if (e === '' || e == null) {
      notification?.error({ message: 'Please enter details for search', placement: 'bottomRight' });
    } else {
      setQueryParams((pre) => ({ ...pre, currentPage: 1, offset: 0, search: e }));
      setTrigerApi(!trigerApi);
    }
  };

  const handlePagePageChange = (page, pageSize) => {
    if (queryParams?.limit !== pageSize) {
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: 0, currentPage: 1 }));
      setTrigerApi(!trigerApi);
    } else {
      const countOffset = page * queryParams?.limit - queryParams?.limit;
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: countOffset, currentPage: page }));
      setTrigerApi(!trigerApi);
    }
  };
  const handleSearchData = () => {
    if (delayTimer) {
      clearTimeout(delayTimer);
    }
    const newTimer = setTimeout(() => {
      handleRefresh();
    }, 1500);
    setDelayTimer(newTimer);
  };
  const handleRefresh = (isRefresh = true) => {
    if (isRefresh) {
      setSearch(null);
    } else {
      setIsFilterModalOpen(false);
    }
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, search: '', filtersData: isRefresh ? pre?.filtersData : null }));
    setTrigerApi(!trigerApi);
  };
  const handleCloseFilterModel = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
  const handleFiltersSearch = (data) => {
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, filtersData: data }));
    setTrigerApi(!trigerApi);
  };
  const filterToggler = () => {
    setFilterToggle(true);
  };
  const handleReset = () => {
    setQueryParams((prev) => ({ ...prev, offset: 0, currentPage: 1, filtersData: {} }));
    setTrigerApi(!trigerApi);
    setIsFilterModalOpen(false);
  };
  const popOverContent = (
    <div className='popOver'>
      <div className='popover_header mt-2 mb-3 flex items-center gap-2'>
        <span style={{ fontWeight: '700', color: '#262626' }}>Filter</span>
        <div className='flex items-center text-[#000000] gap-2 cursor-pointer' onClick={() => handleReset()}>
          <ReloadOutlined style={{ fontSize: '16px' }} />
          <span style={{ color: '#000000', fontSize: '14px', lineHeight: '24px' }}>Reset All</span>
        </div>
      </div>
      <div className='intentFilters'>
        <Filter filterToggler={filterToggler} filtersData={queryParams?.filtersData} onSearch={handleFiltersSearch} handleClose={handleCloseFilterModel} />
      </div>
    </div>
  );
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Account Settings',
      },
      {
        name: 'Billing & Usage',
      },
    ],
  };
  const handleRowHover = () => {
    setRecordId('');
  };
  const handleSearch = (e) => {
    if (delayTimer && e !== '' && e !== null) {
      clearTimeout(delayTimer);
    }
    setSearch(e?.target?.value);
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div className='header-container'>
        <Breadcrumbs {...breadcrumbProps} />
        <div className='headerPage'>
          <div className='mb-0'>
            <PageHeader label='Billing & Usage' button={<ResetButton onClick={isFetching ? '' : handleRefresh} loading={isFetching} />} />
          </div>
        </div>
      </div>
      <div className='actionPanel'>
        <div className='headerContainer' style={{ width: '100%' }}>
          <Popover
            className={isFilterModalOpen ? 'filter-active filterPopover' : filterToggle ? 'text-base activeFilterToggler filterPopover' : 'text-base filterPopover'}
            trigger='click'
            placement='bottomLeft'
            content={popOverContent}
            open={isFilterModalOpen}
            destroyTooltipOnHide
            onOpenChange={() => {
              handleCloseFilterModel();
            }}>
            <FilterButton onClick={() => setIsFilterModalOpen(true)}>
              <div className='text-base'>Filter</div>
            </FilterButton>
          </Popover>
          <div className='searchInput' style={{ width: '100%' }}>
            <SearchField
              handleOnChange={handleSearch}
              value={search}
              handlePressEnter={getSearch}
              onReset={handleSearchData}
              placeholder={'Search by Invoice ID'}
              loading={!!(isFetching && search)}
              dropdown={{ show: false }}
              enableSearchBtn={true}
            />
          </div>
        </div>
      </div>
      <br />
      <div className='overflow-x-auto custom-table' ref={tableContainerRef}>
        <Table
          loading={isLoading}
          dataSource={data?.products}
          columns={columnsData}
          scroll={{ x: 'auto' }}
          onRow={(record) => {
            return {
              onClick: (event) => {
                const { className } = event?.target;
                if (!className?.includes('table-action-btn')) {
                  navigate(`/setting/billing/${record?.invoice_id}`, {
                    state: {
                      record,
                      id: record?.invoice_id,
                      filtersData: handleStateByPassData(queryParams),
                      searchValue: search,
                    },
                  });
                }
              },
              onMouseEnter: handleRowHover,
              className: `custom-row-class ${recordId === record?.invoice_id ? 'highlighted-row' : ''}`,
            };
          }}
          totalLenght={data?.count}
          pagingation={{
            handlePageChange: handlePagePageChange,
            perPageSize: queryParams?.limit,
            page: queryParams?.currentPage,
          }}
        />
      </div>
    </div>
  );
};
